/** Theme (light | dark | system) and motion (system | reduce | full), persisted and applied pre-paint (index.html). */
import { savePreference } from './storageChoice';

export type ThemePref = 'light' | 'dark' | 'system';
export type MotionPref = 'system' | 'reduce' | 'full';

function read(key: string, fallback: string) {
  try {
    return localStorage.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
}
function write(key: 'rmp2.theme' | 'rmp2.motion', value: string) {
  savePreference(key, value); // honours the person's storage choice; private mode simply doesn't persist
}

export function getThemePref(): ThemePref {
  return read('rmp2.theme', 'system') as ThemePref;
}
export function applyTheme(pref: ThemePref) {
  write('rmp2.theme', pref);
  const dark = pref === 'dark' || (pref === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
}
export function getMotionPref(): MotionPref {
  return read('rmp2.motion', 'system') as MotionPref;
}
export function applyMotion(pref: MotionPref) {
  write('rmp2.motion', pref);
  const reduce = pref === 'reduce' || (pref === 'system' && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  document.documentElement.dataset.motion = reduce ? 'reduce' : 'full';
}
/** Scripted motion reads the SAME source of truth as the stylesheet (§11 layer 4). */
export function motionReduced(): boolean {
  return document.documentElement.dataset.motion === 'reduce';
}
